/**
 * 营销推广
 */

import Layout from '@/views/layout'

export default [
  {
    path: '/promotion',
    name: 'promotion',
    redirect: '/promotion/center',
    component: Layout,
    meta: {
      title: '活动营销',
      icon: 'activeMarket.png',
      index: 16
    },
    children: [
      {
        path: 'centerShow',
        name: 'centerShow',
        componentName: 'center_show',
        meta: {
          title: '活动广场'
        },
        component: () => import('@/views/marketPromotion/centerShow')
      },
      {
        path: 'sendWater',
        name: 'sendWater',
        componentName: 'send_water',
        hidden: true,
        meta: {
          title: '加油送水'
        },
        component: () => import('@/views/marketPromotion/centerShowComponents/sendWater')
      },
      {
        path: 'comeOrder',
        name: 'comeOrder',
        componentName: 'come_order',
        hidden: true,
        meta: {
          title: '加油冲单'
        },
        component: () => import('@/views/marketPromotion/centerShowComponents/comeOrder')
      },
      {
        path: 'limitShop',
        name: 'limitShop',
        hidden: true,
        meta: {
          title: '限时秒杀'
        },
        component: () => import('@/views/marketPromotion/centerShowComponents/limitShop')
      },
      {
        path: 'daySpecial',
        name: 'daySpecial',
        hidden: true,
        meta: {
          title: '天天特价'
        },
        component: () => import('@/views/marketPromotion/centerShowComponents/daySpecial')
      },
      {
        path: 'treasure',
        name: 'treasure',
        hidden: true,
        meta: {
          title: '抽奖宝'
        },
        component: () => import('@/views/marketPromotion/centerShowComponents/treasure')
      },
      {
        path: 'vipDraw',
        name: 'vipDraw',
        hidden: true,
        meta: {
          title: '会员画像'
        },
        component: () => import('@/views/marketPromotion/centerShowComponents/vipDraw')
      },
      {
        path: 'center',
        name: 'center',
        hidden: true,
        meta: {
          title: '营销中心绑定'
        },
        component: () => import('@/views/marketPromotion/waterSign')
      },
      {
        path: 'daySpecialSign',
        name: 'daySpecialSign',
        hidden: true,
        meta: {
          title: '天天特价报名'
        },
        component: () => import('@/views/marketPromotion/daySpecialSign')
      },
      {
        path: 'limitShopSign',
        name: 'limitShopSign',
        hidden: true,
        meta: {
          title: '限时秒杀报名'
        },
        component: () => import('@/views/marketPromotion/limitShopSign')
      },
      {
        path: 'treasureSign',
        name: 'treasureSign',
        hidden: true,
        meta: {
          title: '抽奖宝报名'
        },
        component: () => import('@/views/marketPromotion/treasureSign')
      },
      // {
      //   path: 'myPromotion',
      //   name: 'myPromotion',
      //   meta: {
      //     title: '审核列表',
      //     id: '1628236410',
      //     trackName: '审核中心'
      //   },
      //   component: () => import('@/views/marketPromotion/myPromotion')
      // },
      {
        path: 'myProDetail',
        name: 'myProDetail',
        hidden: true,
        meta: {
          title: '审核详情'
        },
        component: () => import('@/views/marketPromotion/myProComponents/myProDetail')
      },
      {
        path: 'activeList',
        name: 'activeList',
        meta: {
          title: '我的活动',
          id: '1632832584',
          trackName: '活动营销 - 我的活动'
        },
        component: () => import('@/views/marketShop/marketList')
      },
      {
        path: 'effectAnalyze',
        name: 'effectAnalyze',
        hidden: true,
        meta: {
          title: '天天特价效果分析'
        },
        component: () => import('@/views/marketShop/subPages/marketList/effectSpecialPrice')
      },
      {
        path: 'dataDetail',
        name: 'dataDetail',
        meta: {
          title: '营销数据'
        },
        component: () => import('@/views/marketPromotion/activeData/detail')
      },
      {
        path: 'runAchieve',
        name: 'runAchieve',
        hidden: true,
        meta: {
          title: '加油冲单活动报名'
        },
        component: () => import('@/views/marketPromotion/runAchieve/signUp')
      },
      {
        path: 'marketing',
        name: 'marketing',
        hidden: true,
        meta: {
          title: '增长计划'
        },
        component: () => import('@/views/marketPromotion/marketing')
      }, {
        path: 'journeySubsidy',
        name: 'journeySubsidy',
        hidden: true,
        meta: {
          title: '路程补贴'
        },
        component: () => import('@/views/marketPromotion/centerShowComponents/journeySubsidy.vue')
      }, {
        path: 'liaoyuanActivity',
        name: 'liaoyuanActivity',
        hidden: true,
        meta: {
          title: '燎原活动'
        },
        component: () => import('@/views/marketPromotion/centerShowComponents/liaoyuanActivity.vue')
      }
    ]
  }
]
